<script lang="ts">
  import { onMount, untrack } from "svelte"
  import type { OrganizationFrame } from "@kontextwerk/control-web-client"
  import type { OrgaViewFrameContext } from "../../../../../../context"
  import { createUsersDirectory } from "../../_shared/_logic/users-directory"
  import UsersTable from "./_modules/users-table"

  const {
    viewFrameContext,
    organization,
  }: { viewFrameContext: OrgaViewFrameContext; organization: OrganizationFrame } = $props()

  // One directory per mounted organization owner; the parent keys this tab by organization.
  const directory = untrack(() =>
    createUsersDirectory({
      organizationId: organization.id,
      roles: viewFrameContext.permissions.allows("core.roles", "view"),
      manage: viewFrameContext.permissions.allows("core.memberships", "manage"),
    }),
  )

  onMount(() => {
    void directory.load()

    return () => directory.dispose()
  })
</script>

{#if directory.available}
  <UsersTable
    {organization}
    {directory}
    permissions={viewFrameContext.permissions}
    currentMembershipId={viewFrameContext.currentMembershipId}
    onMembersChanged={() => viewFrameContext.refreshOrganization()}
  />
{:else}
  <p class="state" role="status">Zugang zur Benutzerverwaltung nicht bestätigt.</p>
{/if}

<style lang="less">
  .state {
    margin: 0;
    color: var(--text-invers-100);
  }
</style>
